var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitreadIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 19C10.6318 18.2101 9.07983 17.7943 7.5 17.7943C5.92017 17.7943 4.36817 18.2101 3 19V6.00002C4.36817 5.21011 5.92017 4.79425 7.5 4.79425C9.07983 4.79425 10.6318 5.21011 12 6.00002M12 19C13.3682 18.2101 14.9202 17.7943 16.5 17.7943C18.0798 17.7943 19.6318 18.2101 21 19V6.00002C19.6318 5.21011 18.0798 4.79425 16.5 4.79425C14.9202 4.79425 13.3682 5.21011 12 6.00002M12 19V6.00002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitreadIco);
export default __webpack_public_path__ + "static/media/gitread-ico.056dfbcddd1b4b3e474bba503580ee6c.svg";
export { ForwardRef as ReactComponent };